<div class="row my-4">
	<label class="form-label fw-bold">Indisponibilités</label>
	<div class="row mt-2 text-dark">
		<div
			*ngFor="let unavailability of employee.unavailabilities; let i = index"
			class="row my-2"
		>
			<div class="col-2 pt-2">
				<span>{{ unavailability.day | titlecase }}</span>
			</div>
			<div class="col-1 pt-2">
				<span>de</span>
			</div>
			<div class="col-2">
				<timepicker
					[showMeridian]="false"
					[readonlyInput]="true"
					[showSpinners]="false"
					[(ngModel)]="unavailabilitiesMapped[i].startDate"
					[ngModelOptions]="{ standalone: true }"
					class="bg-transparent border-light ps-0"
				>
				</timepicker>
			</div>
			<div class="col-1 pt-2">
				<span>à</span>
			</div>
			<div class="col-2">
				<timepicker
					[showMeridian]="false"
					[readonlyInput]="true"
					[showSpinners]="false"
					[(ngModel)]="unavailabilitiesMapped[i].endDate"
					[ngModelOptions]="{ standalone: true }"
				>
				</timepicker>
			</div>
			<div class="col-2 d-grid">
				<button class="btn theme-red-button" (click)="deleteUnavailability(i)">
					<i class="bi bi-x-lg" aria-hidden="true" aria-hidden="true"></i>
					Supprimer
				</button>
			</div>
		</div>
	</div>
	<div class="row text-dark">
		<div class="row mt-2">
			<div class="col-2">
				<select
					class="form-select"
					id="unavailabilityDayAdd"
					[(ngModel)]="newUnavailability.day"
					[ngModelOptions]="{ standalone: true }"
					name="unavailabilityDayAdd"
					#unavailabilityDay{{i}}="ngModel"
				>
					<option [ngValue]="undefined" selected>Jour</option>
					<option *ngFor="let day of weekDays" value="{{ day }}">
						{{ day | titlecase }}
					</option>
				</select>
			</div>
			<div class="col-1 pt-2">
				<span>de</span>
			</div>
			<div class="col-2">
				<timepicker
					[showMeridian]="false"
					[showSpinners]="false"
					[(ngModel)]="newUnavailabilityMapped.startDate"
					[ngModelOptions]="{ standalone: true }"
					class="bg-transparent border-light ps-0"
					(change)="checkTime(unavailabilityString)"
					(wheel)="checkTime(unavailabilityString)"
					(keypress)="checkTime(unavailabilityString)"
				>
				</timepicker>
			</div>
			<div class="col-1 pt-2">
				<span>à</span>
			</div>
			<div class="col-2">
				<timepicker
					(change)="checkTime(unavailabilityString)"
					(wheel)="checkTime(unavailabilityString)"
					(keypress)="checkTime(unavailabilityString)"
					[showMeridian]="false"
					[showSpinners]="false"
					[(ngModel)]="newUnavailabilityMapped.endDate"
					[ngModelOptions]="{ standalone: true }"
				>
				</timepicker>
			</div>
			<div class="col-2 d-grid">
				<button
					class="btn theme-main-color-button"
					(click)="addNewUnavailability()"
					[disabled]="
						!checkTime(unavailabilityString) ||
						!newUnavailability.day ||
						!newUnavailabilityMapped.startDate ||
						!newUnavailabilityMapped.endDate
					"
				>
					<i class="bi bi-plus-lg" aria-hidden="true"></i>
					Ajouter
				</button>
			</div>
		</div>
		<div *ngIf="!checkTime(unavailabilityString)">
			<span class="text-danger"
				>Veuillez saisir une heure de début inférieur à l'heure de fin</span
			>
		</div>
	</div>
</div>

<!-- SAE Service aide à l'emploi : saisie des disponibilités -->
<div *ngIf="isSAE" class="row my-4">
	<label class="form-label fw-bold"
		>Disponibilités Services d'Appui à l'Emploi</label
	>
	<div class="row mt-2 text-dark">
		<div
			*ngFor="let availability of availabilities; let i = index"
			class="row my-2"
		>
			<div class="col-1 pt-2">
				<span>{{
					getAvailabilityCareSkill(availability.availabilityCareSkillId)
						| titlecase
				}}</span>
			</div>
			<div class="col-1 pt-2">
				<span>{{ getAvailabilityDay(availability.weekDay) | titlecase }}</span>
			</div>
			<div class="col-1 pt-2">
				<span>de</span>
			</div>
			<div class="col-2">
				<timepicker
					[showMeridian]="false"
					[readonlyInput]="true"
					[showSpinners]="false"
					[(ngModel)]="availabilitiesMapped[i].startTime"
					[ngModelOptions]="{ standalone: true }"
					class="bg-transparent border-light ps-0"
				>
				</timepicker>
			</div>
			<div class="col-1 pt-2">
				<span>à</span>
			</div>
			<div class="col-2">
				<timepicker
					[showMeridian]="false"
					[readonlyInput]="true"
					[showSpinners]="false"
					[(ngModel)]="availabilitiesMapped[i].endTime"
					[ngModelOptions]="{ standalone: true }"
				>
				</timepicker>
			</div>
			<div class="col-2 d-grid">
				<button
					class="btn theme-red-button"
					(click)="deleteAvailability(availability)"
				>
					<i class="bi bi-x-lg" aria-hidden="true" aria-hidden="true"></i>
					Supprimer
				</button>
			</div>
		</div>
	</div>
	<div class="row text-dark">
		<div class="row mt-2">
			<div class="col-1">
				<select
					class="form-select"
					id="availabilityCareSkillAdd"
					[(ngModel)]="newAvailability.availabilityCareSkillId"
					[ngModelOptions]="{ standalone: true }"
					name="availabilityCareSkillAdd"
					#availabilityCareSkill{{i}}="ngModel"
				>
					<option [ngValue]="undefined" selected>Compétence</option>
					<option
						*ngFor="let careSkill of availabilityCareSkills; let i = index"
						[ngValue]="careSkill.id"
					>
						{{ careSkill.name | titlecase }}
					</option>
				</select>
			</div>
			<div class="col-1">
				<select
					class="form-select"
					id="availabilityDayAdd"
					[(ngModel)]="newAvailability.weekDay"
					[ngModelOptions]="{ standalone: true }"
					name="availabilityDayAdd"
					#availabilityDay{{i}}="ngModel"
				>
					<option [ngValue]="undefined" selected>Jour</option>
					<option *ngFor="let day of weekDays; let i = index" [ngValue]="i + 1">
						{{ day | titlecase }}
					</option>
				</select>
			</div>
			<div class="col-1 pt-2">
				<span>de</span>
			</div>
			<div class="col-2">
				<timepicker
					[showMeridian]="false"
					[showSpinners]="false"
					[(ngModel)]="newAvailabilityMapped.startTime"
					[ngModelOptions]="{ standalone: true }"
					class="bg-transparent border-light ps-0"
					(change)="checkTime(availabilityString)"
					(wheel)="checkTime(availabilityString)"
					(keypress)="checkTime(availabilityString)"
				>
				</timepicker>
			</div>
			<div class="col-1 pt-2">
				<span>à</span>
			</div>
			<div class="col-2">
				<timepicker
					(change)="checkTime(availabilityString)"
					(wheel)="checkTime(availabilityString)"
					(keypress)="checkTime(availabilityString)"
					[showMeridian]="false"
					[showSpinners]="false"
					[(ngModel)]="newAvailabilityMapped.endTime"
					[ngModelOptions]="{ standalone: true }"
				>
				</timepicker>
			</div>
			<div class="col-2 d-grid">
				<button
					class="btn theme-main-color-button"
					(click)="addNewAvailability()"
					[disabled]="
						!checkTime(availabilityString) ||
						!newAvailability.weekDay ||
						!newAvailability.availabilityCareSkillId ||
						!newAvailabilityMapped.startTime ||
						!newAvailabilityMapped.endTime
					"
				>
					<i class="bi bi-plus-lg" aria-hidden="true"></i>
					Ajouter
				</button>
			</div>
		</div>
		<div *ngIf="!checkTime(availabilityString)">
			<span class="text-danger"
				>Veuillez saisir une heure de début inférieur à l'heure de fin</span
			>
		</div>
	</div>
</div>
